import React from 'react';

const StuClassShedule = () => {
    return (
        <div>
           
        </div>
    );
};

export default StuClassShedule;